// @ts-nocheck
import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import AffiliateShell from './components/AffiliateShell'
import {AFF, card} from './components/affiliateTheme'
import {addAffiliateCustomer} from './core/_requests'

const Field = ({label, required, children}) => (
  <div className='col-md-6'>
    <label style={{fontWeight: 600, color: AFF.ink, marginBottom: 6, display: 'block'}}>
      {label} {required && <span style={{color: AFF.danger}}>*</span>}
    </label>
    {children}
  </div>
)

const AffiliateAddCustomerWrapper = () => {
  const navigate = useNavigate()
  const [form, setForm] = useState({name: '', email: '', phone: '', company_name: '', password: ''})
  const [saving, setSaving] = useState(false)
  const [result, setResult] = useState<any>(null)

  const set = (k) => (e) => setForm({...form, [k]: e.target.value})
  const inputStyle = {border: `1px solid ${AFF.border}`}

  const submit = async (e) => {
    e.preventDefault()
    setSaving(true)
    setResult(null)
    try {
      const res = await addAffiliateCustomer(form)
      if (res.data?.success) {
        setResult({ok: true, message: 'הלקוח נוצר עם 14 יום ניסיון חינם ✓'})
        setTimeout(() => navigate('/affiliate/customers'), 1300)
      } else {
        setResult({ok: false, message: res.data?.message || 'שגיאה ביצירת הלקוח'})
      }
    } catch (err: any) {
      setResult({ok: false, message: err?.response?.data?.message || err?.message})
    }
    setSaving(false)
  }

  return (
    <AffiliateShell title='הוספת לקוח חדש' subtitle='צור חשבון ללקוח עם 14 יום ניסיון חינם, משויך אליך אוטומטית.'>
      <div className='row g-4'>
        <div className='col-lg-8'>
          <div style={{...card, padding: 28}}>
            <form onSubmit={submit}>
              <div className='row g-4'>
                <Field label='שם מלא' required>
                  <input className='form-control' style={inputStyle} value={form.name} onChange={set('name')} required />
                </Field>
                <Field label='טלפון' required>
                  <input className='form-control' style={inputStyle} dir='ltr' value={form.phone} onChange={set('phone')} required />
                </Field>
                <Field label='אימייל (לא חובה)'>
                  <input className='form-control' style={inputStyle} type='email' dir='ltr' value={form.email} onChange={set('email')} placeholder='ברירת מחדל: לפי הטלפון' />
                </Field>
                <Field label='שם עסק'>
                  <input className='form-control' style={inputStyle} value={form.company_name} onChange={set('company_name')} />
                </Field>
                <Field label='סיסמה (אופציונלי — תיווצר אוטומטית)'>
                  <input className='form-control' style={inputStyle} dir='ltr' value={form.password} onChange={set('password')} placeholder='השאר ריק ליצירה אוטומטית' />
                </Field>
              </div>

              {result && (
                <div
                  style={{
                    marginTop: 20,
                    padding: '12px 16px',
                    borderRadius: 12,
                    fontWeight: 600,
                    background: result.ok ? '#e8fff3' : '#fff5f8',
                    color: result.ok ? AFF.success : AFF.danger,
                  }}
                >
                  {result.message}
                </div>
              )}

              <div style={{marginTop: 24}}>
                <button className='btn' type='submit' disabled={saving} style={{background: AFF.accentGrad, color: '#fff', fontWeight: 700, padding: '10px 28px', borderRadius: 10}}>
                  {saving ? 'יוצר…' : 'צור לקוח'}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className='col-lg-4'>
          <div style={{...card, padding: 24}}>
            <div style={{fontWeight: 700, color: AFF.ink, marginBottom: 14}}>איך זה עובד?</div>
            {[
              ['bi-person-plus', 'מוסיף את הלקוח עם 14 יום ניסיון חינם'],
              ['bi-box-arrow-in-right', 'נכנס לחשבון הלקוח כדי לעזור בחיבור הפרופילים'],
              ['bi-houses', 'מייבא פוסטים מיד2 כדי שיתחיל לעבוד מיד'],
              ['bi-cash-coin', 'מקבל עמלה כשהלקוח מבצע תשלום ראשון'],
            ].map(([icon, txt], i) => (
              <div key={i} style={{display: 'flex', gap: 12, alignItems: 'flex-start', marginBottom: 14}}>
                <div style={{width: 34, height: 34, borderRadius: 9, background: AFF.accentSoft, color: AFF.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                  <i className={`bi ${icon}`} />
                </div>
                <div style={{color: AFF.ink, fontSize: 14, paddingTop: 5}}>{txt}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AffiliateShell>
  )
}

export default AffiliateAddCustomerWrapper
